import {euroPrice} from "../utils";
import * as Checkbox from '@radix-ui/react-checkbox';

function PriceCheckbox({label, instructionLabel, fieldName, checked, onChange, price, disabled}){
    return <>
        <div className="price-checkbox">
            <label>
                <Checkbox.Root
                    name={fieldName}
                    checked={!!checked}
                    disabled={disabled}
                    onCheckedChange={(c) => onChange(c)}
                    className={'checkbox-root'}
                >
                    <Checkbox.Indicator className={'checkbox-indicator'}>
                        <svg viewBox={'0 0 27 27'} width={27} height={27}>
                            <path id="Icon_material-check-box" fill={'#fff'}
                                  d="M10.5,21L3,13.5l2.1-2.1l5.4,5.4L21.9,5.4L24,7.5L10.5,21z"/>
                        </svg>
                    </Checkbox.Indicator>
                </Checkbox.Root>

                <span>{label}&nbsp;{instructionLabel && <sup>{instructionLabel}</sup>}</span>
            </label>
            <div>{checked && price!==0 ? euroPrice(price) : '-'}</div>
        </div>
        <hr/>
    </>;
}

export default PriceCheckbox;